// extracted by mini-css-extract-plugin
export var card = "_5y-0";
export var expandedCard = "_5y-2";
export var paginated = "_5y-1";